module.exports = __webpack_public_path__ + "img/mainmenu-es.d02483b6.png";